import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import {BasicAnimation} from "../animations/BasicAnimation";

export class Article extends React.Component {

  render(){
    return (
      <Container className={"article-container"}>
        <Row>
          <Col xs={{ size: 12}} md={{ size: 10, offset: 1}} className="pt-5 pb-5">
            <BasicAnimation duration={400} delay={0}>
            <div dangerouslySetInnerHTML={{
                __html:  typeof this.props.content === 'string' ? this.props.content : ""
              }}/>
            </BasicAnimation>
          </Col>
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/article/Article.js